import HeaderMedia from "./HeaderMedia";

export default HeaderMedia;
